export const NAMESPACE = 'INVITATIONS/';
export const FETCH = `${NAMESPACE}FETCH`;
export const DELETE = `${NAMESPACE}DELETE`;
export const SET_PARAMS = `${NAMESPACE}SET_PARAMS`;
export const RESET = `${NAMESPACE}RESET`;
